<template>
  <Ethereum :callback="initialize" />
  <div class="confirmBurn">
    <div class="container">
      <div class="descriptionWrapper">
        <div class="title">Confirm Burn</div>
        <div class="warning">
          <WarningIcon />
          <strong>WARNING!</strong>
          <div>
            Burning your Bull will permanently erase it from existence. There is
            no way to reverse this process. But you will end up with 2 juicy,
            delicious, one-of-a-kind Astro Burger NFTs.
          </div>
        </div>
      </div>

      <div class="itemsGrid">
        <NFTCard
          :fren="fren"
          v-for="fren in selectedFrens"
          :key="fren.id"
          :class="fren.isSelected ? 'selected' : ''"
        />
      </div>
      <div class="burnButtonWrapper">
        <Button @click="confirmBurn">
          Confirm Burn {{ selectedFrens.length }} {{ bullLabel }}
        </Button>
        <div class="cancel" @click="router.go(-1)">Cancel</div>
      </div>
    </div>
  </div>
</template>
<script>
// Imports.
import { ref, watch, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';

// Component imports.
import NFTCard from '../my-frens/components/NFTCard.vue';
import Ethereum from '/src/components/common/Ethereum.vue';
import Button from '/src/components/ui/Button.vue';

// Icon imports.
import WarningIcon from '/src/components/icons/WarningIcon.vue';

export default {
  components: {
    NFTCard,
    Ethereum,
    Button,
    WarningIcon
  },

  props: ['frens'],

  setup(props) {
    const store = useStore();
    const selected = ref();
    const router = useRouter();

    const loading = ref(false);
    if (store.state.mint.frens.length === 0) loading.value = true;
    // Once the state variable changes, the watch is triggered.
    watch(
      () => store.state.mint.frens,
      selection => {
        loading.value = false;
      }
    );

    // Retrieve the the user's owned frens.
    const initialize = () => {
      const address = store.state.ethers.address;
      const groupId = 1;
      store.dispatch('mint/getFrens', { address, groupId }, { root: true });
    };

    const selectedFrens = computed(() => {
      let frenIds = new Set(props.frens);

      return store.state.mint.frens.filter(fren => frenIds.has(fren.id));
    });

    const bullLabel = computed(() => {
      return selectedFrens.value.length === 1 ? 'Bull' : 'Bulls';
    });

    const confirmBurn = () => {
      let ids = [];
      let groupOut = 2;
      for(let i = 0; i < selectedFrens.value.length; i++){
        ids.push("0x"+selectedFrens.value[i].id);
      }
      store.dispatch('burn/burn', {ids, groupOut}, { root: true });
      router.go(-1);
      const groupId = 1;
      const address = store.state.ethers.address;
      store.dispatch('mint/getFrens', { address, groupId }, { root: true });
    };

    return {
      store,
      initialize,
      loading,
      selected,
      selectedFrens,
      bullLabel,
      confirmBurn,
      router
    };
  }
};
</script>
<style scoped lang="scss">
.confirmBurn {
  padding: 60px 20px;
  color: white;

  .container {
    width: 1800px;
    max-width: 90%;
    margin-right: auto;
    margin-left: auto;

    .descriptionWrapper {
      display: flex;
      margin-bottom: 40px;
      flex-direction: column;
      align-items: center;
      text-align: center;

      .title {
        margin-top: 0px;
        margin-bottom: 20px;
        font-family: Montserrat, sans-serif;
        color: #ffd915;
        font-size: 90px;
        line-height: 1em;
        font-weight: 700;
        text-align: center;
        text-transform: uppercase;
      }

      .warning {
        box-sizing: border-box;
        max-width: 64ch;
        margin-bottom: 20px;
        padding: 20px;
        background-color: #ffd915;
        color: #000;
        font-weight: 700;
        display: grid;
        grid-template-columns: 1fr;
        justify-items: center;
        grid-row-gap: 10px;
      }
    }

    .itemsGrid {
      display: grid;
      width: 100%;
      justify-content: center;
      justify-items: center;
      grid-auto-columns: 1fr;
      grid-auto-rows: 1fr;
      grid-column-gap: 20px;
      grid-row-gap: 20px;
      grid-template-columns: repeat(auto-fit, minmax(300px, min-content));
      grid-template-rows: 1fr;
    }

    .burnButtonWrapper {
      position: sticky;
      left: 0px;
      right: 0px;
      bottom: 0px;
      z-index: 5;
      display: grid;
      min-height: 60px;
      margin-bottom: 40px;
      padding: 60px 30px;
      justify-content: center;
      justify-items: center;
      grid-column-gap: 20px;
      grid-row-gap: 20px;
      grid-template-columns: auto;
      grid-template-rows: auto;
      background-image: linear-gradient(0deg, #000 50%, transparent);

      .cancel {
        transition: opacity 200ms cubic-bezier(0.215, 0.61, 0.355, 1);
        color: #fff;
        opacity: 0.6;
        font-size: 20px;
        text-decoration: none;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }

        &:active {
          opacity: 1;
        }
      }
    }
  }
}
</style>
